<div class="mt-4 flex flex-col">
    @if (showAlert()) {
        <fuse-alert class="mb-4" [type]="alertType()" [dismissible]="false">
            <div class="whitespace-pre-line">{{ alertMessage() }}</div>
        </fuse-alert>
    }
    @if (exportCompleted()) {
        @if (exportSummary()) {
            <div class="rounded-lg border border-gray-200 bg-gray-50 p-4">
                <h3 class="mb-3 text-lg font-semibold">Zusammenfassung</h3>
                <div class="space-y-2 text-sm">
                    <div class="flex justify-between">
                        Dateiname:
                        <span class="text-gray-900">{{ exportSummary().fileName }}</span>
                    </div>
                    <div class="flex justify-between">
                        Quellordner:
                        <span class="text-gray-900">{{ exportSummary().directoryNames }}</span>
                    </div>
                    <div class="flex justify-between">
                        Exportierte Prompts:
                        <span class="font-semibold text-green-600">{{ exportSummary().exportedCount }}</span>
                    </div>
                </div>
            </div>
        }
    } @else {
        <mat-accordion class="flex flex-col gap-1" [multi]="true">
            @for (directory of allDirectories(); track directory.uid) {
                <mat-expansion-panel class="my-0 border border-gray-100">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-checkbox
                                [checked]="areAllPromptsSelected(directory)"
                                (click)="$event.stopPropagation()"
                                [indeterminate]="areSomePromptsSelected(directory) && !areAllPromptsSelected(directory)"
                                (change)="toggleDirectorySelection(directory.uid, $event.checked)">
                                {{ directory.name }}
                            </mat-checkbox>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-expansion-panel-content class="pb-4">
                        @for (prompt of directory.prompts; track prompt.uid) {
                            <div class="pl-6">
                                <mat-checkbox
                                    [checked]="isSelected(prompt.uid)"
                                    (change)="togglePromptSelection(prompt.uid, $event.checked)">
                                    {{ prompt.name }}
                                </mat-checkbox>
                            </div>
                        } @empty {
                            <div class="pl-6 text-base text-gray-500">Keine Prompts in diesem Verzeichnis.</div>
                        }
                    </mat-expansion-panel-content>
                </mat-expansion-panel>
            }
        </mat-accordion>
    }
</div>
